import { CreditTaskComment } from '../../types'
import { createEntityApi } from '../make-api'

const BASE_URL = '/Applications/{financingProgramId}/{creditApplicationId}/Tasks/{taskId}/Comments'
const creditTaskCommentApi = {
  ...createEntityApi<CreditTaskComment>(BASE_URL),
}

export default creditTaskCommentApi
